import {
  Component,
  Inject,
  OnInit,
} from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { TableListSelectComponent } from '../../../shared/components/table-list-select/table-list-select.component'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { ServiceOrderService } from '../../../core/services/service/service-order/service-order.service'
import { ServiceOrderReplier } from '../service-order-replier/service-order-replier.component'
import { ServiceOrder } from '../service-order/service-order.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import {
  FormSearchOsProposalClientComponent
} from '../../../shared/components/form-search-os-proposal-client/form-search-os-proposal-client.component'
import { TableListOSComponent } from '../../../shared/components/table-list-os/table-list-os.component'
import { JsonPipe } from '@angular/common'
import { FormSearchOsNewComponent } from '../../../shared/components/form-search-os-new/form-search-os-new.component'
import { MatDivider } from '@angular/material/divider'

@Component({
  selector: 'modal-order-service-proposal',
  imports: [
    FormSearchComponent,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    TableListSelectComponent,
    MatButton,
    MatProgressSpinner,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    FormSearchOsProposalClientComponent,
    TableListOSComponent,
    MatPaginator,
    JsonPipe,
    FormSearchOsNewComponent,
    MatDivider,
  ],
  templateUrl: './modal-order-service-proposal.component.html',
  styleUrl: './modal-order-service-proposal.component.scss',
  standalone: true,
  providers: [EmployeeService],
})
export class ModalOrderServiceProposalComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalOrderServiceProposalComponent>,
    private serviceOrderService: ServiceOrderService,
    private authService: AuthService,
  ) {
    this.data = data.item
  }

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  searchResult: any = {}
  loading = false
  // searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  searchForm: any = { search: false, model: {} }
  inputSearch = ''

  columns: any[] = [
    {
      keyColumn: 'codeOs',
      key: 'codigoOs',
      description: 'Codigo Os',
    },
    {
      keyColumn: 'os_service',
      key: 'tipoServico',
      description: 'Serviço',
    },
    {
      keyColumn: 'os_vehicle',
      key: 'nomeTipoVeiculo',
      description: 'Veículo',
    },
    {
      keyColumn: 'os_period',
      key: 'os_period',
      description: 'Periodo',
    },
    {
      keyColumn: 'pax',
      key: 'quantidadePassageiros',
      description: 'Quantidade Passageiros',
    },
    {
      keyColumn: 'statusOs',
      key: 'descricaoStatusOs',
      description: 'Status',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, replierItem: false },
      description: 'Ações',
    },
  ]
  screen = 'tipo serviço'

  ngOnInit() {
    this.checkColumnAction()
    // this.getListItems()
    // this.searchOs()
    this.getSearchItems({
      codigoOs: '',
      evento: '',
      dataInicio: '',
      dataFinal: '',
      statusId: null,
      codigoTg: this.data.codigoTg,
      clienteId: null,
      // clienteId: this.data.clienteId,
    })
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
        replierItem: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  close() {
    this.dialogRef.close()
  }

  getSearchItems(model: any) {
    this.loading = true
    this.serviceOrderService
      .searchPagedServiceOrder(this.page, this.rows, model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: PagedContactTypeResponse) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchOs() {
    this.loading = true

    const item = {
      codigoOs: '',
      evento: '',
      dataInicio: '',
      dataFinal: '',
      statusId: null,
      codigoTg: '',
      clienteId: null,
    }

    this.searchResult = item

    this.serviceOrderService
      .searchPagedServiceOrder(this.page, this.rows, item)
      .subscribe({
        next: (response: any) => {
          this.loading = false
          this.treatResponse(response)
        },
        error: (err: any) => {
          console.error(err.message)
        },
      })
  }

  createModelSearch(model: any){
    return {
      codigoOs: model.codigoOs,
      evento: '',
      dataInicio: model.dataInicio,
      dataFinal: model.dataFinal,
      statusId:  model.statusId == '' ? null : model.statusId,
      codigoTg: this.data.codigoTg,
      clienteId: null,
    }
  }

  search(event: any) {
    this.searchForm = {search: event.search, model: this.createModelSearch(event.model)}
    this.page = 1
    this.uploadList()
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
    // this.search(this.searchResult)
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
    // this.search(this.searchResult)
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1
    this.uploadList()
  }

  uploadList() {
    if (this.searchForm.search) {
      this.getSearchItems(this.searchForm.model)
    } else {
      this.getSearchItems({
        codigoOs: '',
        evento: '',
        dataInicio: '',
        dataFinal: '',
        statusId: null,
        codigoTg: this.data.codigoTg,
        clienteId: null,
        // clienteId: this.data.clienteId,
      })
    }
    // this.getListItems()
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }

    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.serviceOrderService
      .listPagedServiceOrder(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  // searchListItems() {
  //   this.loading = true
  //   this.serviceOrderService
  //     .searchPagedServiceOrder(this.page, this.rows, this.searchForm)
  //     .subscribe({
  //       next: (response: any) => {
  //         this.treatResponse(response)
  //       },
  //       error: (err: PagedContactTypeResponse) => { },
  //       complete: () => {
  //         this.loading = false
  //       },
  //     })
  // }

  replierItem(item: any) {
    /*

  ordemServicoId: "string",
  ordemServicoIds: ["string"],
  horaInicial: "string",
  horaFinal: "string",
  observacao: true,
  listaPassageiros: true,
  itinerarios: true

*/
    const dialogRef = this.dialog.open(ServiceOrderReplier, {
      data: { item: item, edit: true },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  editItem(item: any) {
    const contratoItemId = item.contratoItemId
    const idOs = item.codigoOs
    const dataFim = item.dataFinal
    const dataInicio = item.dataInicio

    const dialogRef = this.dialog.open(ServiceOrder, {
      data: { item, contratoItemId, idOs, dataInicio, dataFim, edit: true },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
  }

  newPriceQuote() {
    const dialogRef = this.dialog.open(ServiceOrder, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { edit: false },
    })

    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }
}
